import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2
};

const strokePropsRound = {
  ...strokeProps,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const
};

export const ReceiptIcon = createSvgIcon(
  <>
    <path
      d="M20.016 2C18.9026 2 18 4.68629 18 8H20.016C20.9876 8 21.4734 8 21.7741 7.66455C22.0749 7.32909 22.0225 6.88733 21.9178 6.00381C21.6414 3.67143 20.8943 2 20.016 2Z"
      {...strokeProps}
    />
    <path
      d="M18 8.05426V18.6458C18 20.1575 18 20.9133 17.538 21.2108C16.7831 21.6971 15.6161 20.6774 15.0291 20.3073C14.5441 20.0014 14.3017 19.8485 14.0325 19.8397C13.7417 19.8301 13.4949 19.9768 12.9709 20.3073L11.06 21.5124C10.5445 21.8374 10.2868 22 10 22C9.71321 22 9.45546 21.8374 8.94 21.5124L7.02913 20.3073C6.54415 20.0014 6.30166 19.8485 6.03253 19.8397C5.74172 19.8301 5.49493 19.9768 4.97087 20.3073C4.38395 20.6774 3.21687 21.6971 2.46195 21.2108C2 20.9133 2 20.1575 2 18.6458V8.05426C2 5.20025 2 3.77325 2.87868 2.88663C3.75736 2 5.17157 2 8 2H20"
      {...strokePropsRound}
    />
    <path
      d="M12.4375 8.5C12.3131 8.14702 12.0859 7.83935 11.7852 7.61658C11.4844 7.39382 11.1239 7.26614 10.75 7.25H8.25C7.75272 7.25 7.27581 7.44754 6.92417 7.79917C6.57254 8.15081 6.375 8.62772 6.375 9.125C6.375 9.62228 6.57254 10.0992 6.92417 10.4508C7.27581 10.8025 7.75272 11 8.25 11H10.75C11.2473 11 11.7242 11.1975 12.0758 11.5492C12.4275 11.9008 12.625 12.3777 12.625 12.875C12.625 13.3723 12.4275 13.8492 12.0758 14.2008C11.7242 14.5525 11.2473 14.75 10.75 14.75H8.25C7.87609 14.7339 7.51557 14.6062 7.21483 14.3834C6.91409 14.1606 6.6869 13.853 6.5625 13.5"
      {...strokePropsRound}
    />
    <path d="M9.5 5.375V7.25M9.5 14.75V16.625" {...strokePropsRound} />
  </>,
  { displayName: 'ReceiptIcon', viewBox: '0 0 24 24' }
);
